import React, { useState } from "react";
import { Box } from "@mui/material";
import Head from "next/head";
import LoanFormPopupV2 from "../../../src/Drawer/LoanFormPopupV2";
import FAQ from "../../../src/SDK/FAQ/faq";
import TurnoPromiseComponent from "../../../src/SDK/FAQ/turnoPromiseComponent";
import { vehicleFAQs } from "../../../src/constants/brandFaqs";
import { vehiclePromiseList } from "../../../src/constants/vehiclesPromises";
import { imagesWEBP } from "../../../src/constants/webpImages";
import { MemoizedFooter } from "../../../src/layouts/footer";
import { MemoizedHeader } from "../../../src/layouts/header";
import BookVehicleDrawer from "../../../src/modules/Home/Drawer/bookVehicleDrawer";
import MemoizedKeySpecifications from "../../../src/modules/Home/VehiclesV2/KeySpecifications";
import ProductTopBanner from "../../../src/modules/Home/VehiclesV2/ProductTopBanner";
import MemoizedVehicleFeatures from "../../../src/modules/Home/VehiclesV2/VehicleFeatures";
import VehicleLatestList from "../../../src/modules/Home/VehiclesV2/VehicleLatestList";
import VehicleSpecificUseSwiper from "../../../src/modules/Home/VehiclesV2/VehicleSpecificUses";
import WebShare from "../../../src/modules/Lead Capture/WebShare.jsx/WebShare";
import QlDrawerComponent from "../../../src/modules/LeadDataCollection/DrawerComponents/LoanDrawerComponents";
import HeaderDesc from "../../../src/modules/Vehicles/Banner/HeaderDesc";
import MemoizedBrandDealerNear from "../../../src/modules/Vehicles/BrandDealerNear";
import { MemoizedLeadCaptureV2 } from "../../../src/pages/LeadCapture/LeadCaptureV2";
import { keySpecificationsInfo } from "../../../src/constants/vehicleKeySpec";
import MemoizedSearchHeader from "../../../src/modules/Vehicles/searchHeader.jsx";
import Breadcrumbs from "../../../src/components/common/Breadcrumbs";
import { SecondaryHeader } from "../../../src/components/common";
import PricingSelectCityModal from "../../../src/components/PricingPage/PricingSelectCityModal";
import PricingPopularCities from "../../../src/components/PricingPage/PricingPopularCities";

const CommercialVehicleLandingPage = ({
  title = "",
  metaContent = [],
  vehicleLink = "",
  SUB_TEXT = "",
  MOSTLY_BOUGHT_FOR_HEADING = "",
  BUSINESS_BENEFIT_HEADING = "",
  FEATURES_HEADING = "",
  BRAND_DEALER_HEADING = "",
  BRAND_DEALER_DESCRIPITION = "",
  FAQ_HEADING_TEXT = "",
  location = "",
  vehicleDataLocal = [],
  vehicleName = "",
  useCaseData = [],
  noentryData = [],
  latestVehiclesInfo = [],
  H1_HEADING = "",
  BREADCRUMB_ITEMS = [],
  BREADCRUMB_SCHEMA = {},
  secondaryHeaderItems = [],
  priceCities = [],
  pricePathPrefix,
}) => {
  const [activeSectionId, setActiveSectionId] = useState("section-header");
  const [priceCityModalOpen, setPriceCityModalOpen] = useState(false);

  const showSecondaryHeader = Array.isArray(secondaryHeaderItems) && secondaryHeaderItems.length > 0;
  const handlePriceCitySelect = (citySlug) => {
    setPriceCityModalOpen(false);
    const path = pricePathPrefix
      ? `/electric-commercial-vehicles/${pricePathPrefix}/price/${citySlug}`
      : null;
    if (path) window.location.href = path;
  };
  const itemsWithPriceModal = showSecondaryHeader
    ? secondaryHeaderItems.map((item) =>
        item.sectionId === "section-price" && priceCities.length > 0
          ? { ...item, onClick: () => setPriceCityModalOpen(true) }
          : item
      )
    : [];

  const pathParts = pricePathPrefix ? pricePathPrefix.split("/") : [];
  const pathBrand = pathParts[0] || "";
  const pathModel = pathParts.slice(1).join("/") || "";
  const commercialVehicleDisplayName = H1_HEADING && pathBrand
    ? H1_HEADING.replace(new RegExp(`^${pathBrand}\\s+`, "i"), "").trim() || pathModel
    : pathModel;

  return (
    <>
      <Head>
        <title>{title}</title>
        {metaContent?.map((content, index) => (
          <meta
            key={index}
            name={content?.name ? content?.name : ""}
            property={content?.property ? content?.property : ""}
            content={content?.content}
          />
        ))}
        <link rel="canonical" href={vehicleLink} />
        {BREADCRUMB_SCHEMA?.itemListElement?.length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(BREADCRUMB_SCHEMA),
            }}
            defer
          />
        )}
      </Head>

      <body>
        <Box>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <MemoizedHeader scrollWithPage={showSecondaryHeader} />
          </Box>
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <MemoizedSearchHeader isProductPage={true} />
          </Box>
          {showSecondaryHeader && (
            <>
              <SecondaryHeader
                items={itemsWithPriceModal}
                activeSectionId={activeSectionId}
                onActiveSectionChange={setActiveSectionId}
                scrollOffsetTop={70}
              />
              {priceCities.length > 0 && (
                <PricingSelectCityModal
                  isOpen={priceCityModalOpen}
                  onClose={() => setPriceCityModalOpen(false)}
                  currentCitySlug={null}
                  availableCities={priceCities}
                  onSelectCity={handlePriceCitySelect}
                />
              )}
            </>
          )}
          {/* Main component */}
          {!showSecondaryHeader && (
            <Box
              sx={{ display: { xs: "none", md: "block" }, background: "#F3F3F4" }}
            >
              <ProductTopBanner
                location={location}
                vehicle_name={H1_HEADING === "" ? vehicleDataLocal[0]?.name : H1_HEADING}
              />
            </Box>
          )}
          <Box
            sx={{
              position: "relative",
              width: "100%",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "0",
                left: "0",
                zIndex: "120",
                display: { xs: "block", md: "none" },
                width: "100%",
              }}
            >
              <WebShare vehicleData={vehicleDataLocal[0]} />
              <BookVehicleDrawer />
            </Box>
          </Box>
          {showSecondaryHeader ? (
            <Box id="section-price">
              <MemoizedLeadCaptureV2 vehicleDataLocal={vehicleDataLocal} />
            </Box>
          ) : (
            <MemoizedLeadCaptureV2 vehicleDataLocal={vehicleDataLocal} />
          )}

          {showSecondaryHeader ? (
            <Box id="section-specification">
              <MemoizedKeySpecifications
                keySpecifications={keySpecificationsInfo?.[vehicleName]}
                headerInfo={"Key Specifications"}
              />
            </Box>
          ) : (
            <MemoizedKeySpecifications
              keySpecifications={keySpecificationsInfo?.[vehicleName]}
              headerInfo={"Key Specifications"}
            />
          )}

          {showSecondaryHeader ? (
            <Box id="section-summary">
              <HeaderDesc
                HeadingTag="h2"
                heading="Product Highlights"
                subText={SUB_TEXT}
              />
              <HeaderDesc
                HeadingTag="h2"
                heading="Mostly bought for"
              />
            </Box>
          ) : (
            <>
              <HeaderDesc
                HeadingTag="h2"
                heading="Product Highlights"
                subText={SUB_TEXT}
              />
              <HeaderDesc
                HeadingTag="h2"
                heading="Mostly bought for"
              />
            </>
          )}

          <VehicleSpecificUseSwiper
            slidePerView={4}
            data={useCaseData}
            isHeader={false}
            isTitle={false}
            //headerInfo={`Business Benefit with Electric Vehicle`}
          />

          <VehicleSpecificUseSwiper
            slidePerView={4}
            data={noentryData}
            headerInfo={`Business Benefit with Electric Vehicle`}
          />

          <MemoizedVehicleFeatures
            promisesData={vehiclePromiseList?.[vehicleName]}
            headerInfo={FEATURES_HEADING}
          />

          <MemoizedBrandDealerNear
            BannerDealerData={{
              headerInfo: BRAND_DEALER_HEADING ,
              description: BRAND_DEALER_DESCRIPITION,
              desktopImg: imagesWEBP?.locationBanner,
              mobileImg: imagesWEBP?.multibrandstore,
            }}
          />

          {showSecondaryHeader && pricePathPrefix && (
            <PricingPopularCities
              vehicleBrand={pathBrand}
              vehicleName={commercialVehicleDisplayName}
              brand={pathBrand}
              model={pathModel}
            />
          )}

          <Box
            sx={{
              width: "100vw",
              alignItems: "center",
              flexDirection: "column",
              paddingLeft: { xs: "10px", sm: "8%", md: "8%", lg: "8%" },
              paddingRight: { xs: "10px", sm: "8%", md: "8%", lg: "8%" },
              marginTop: "48px",
              paddingTop: "12px",
            }}
          >
            <TurnoPromiseComponent />
            {/* <NewVehicleReview images={images} slidesPerView={isMobile ? 1.4 : 4} /> */}

            <Box style={{ marginTop: "48px" }}>
              <VehicleLatestList latestVehiclesInfo={latestVehiclesInfo} />
            </Box>

            <Box
              sx={{
                padding: { xs: "10px", sm: "10px", md: "20px", lg: "20px" },
              }}
            >
              <FAQ
                faqList={vehicleFAQs?.[vehicleName]}
                showItems={5}
                headText={FAQ_HEADING_TEXT}
              />
            </Box>

            <LoanFormPopupV2 />
            <QlDrawerComponent />
          </Box>

          {Array.isArray(BREADCRUMB_ITEMS) && BREADCRUMB_ITEMS.length > 0 && (
            <Box
              sx={{
                width: { xs: "100%", md: "84%" },
                margin: "20px auto",
                padding: { xs: "0 12px", md: "0" },
              }}
            >
              <Breadcrumbs items={BREADCRUMB_ITEMS} />
            </Box>
          )}

          <MemoizedFooter />
        </Box>
      </body>
    </>
  );
};

export default CommercialVehicleLandingPage;
